import React, { useEffect, useState } from 'react'
import './edit-area.scss'
import MultiSelect from '../../common/inputs/MultiSelect';
import NormalInput from '../../common/inputs/NormalInput';
import { BiLoaderAlt } from 'react-icons/bi'
import { staffAxios, userAxios } from '../../../config/axios';
import toast from 'react-hot-toast';


const EditArea = ({ data, setModal, setArea }) => {
    const [loading, setLoading] = useState('')
    const [form, setForm] = useState({
        staff_ids: data?.technicians?.map((tech) => tech.staff_id) || [],
        pr_get_data_date: data?.pr_get_data_date || ''
    })
    const [staff, setStaff] = useState([])


    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleMultiSelect = (selected) => {
        setForm({
            ...form,
            staff_ids: selected.map((tech) => tech.value)
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!form?.staff_ids?.[0] && !data) {
            toast.error('Select technician')
            return;
        }

        setLoading('submit')

        userAxios.put('/area', {
            city_id: data.city_id,
            staff_ids: form.staff_ids,
            pr_get_data_date: form?.pr_get_data_date
        }).then(() => {
            setModal({ status: false })
            setArea((state) => state.map((area) => {
                if (area.city_id === data.city_id) {
                    let technicians = staff.filter(objB => form.staff_ids.includes(objB.value));
                    technicians = technicians.map((value) => ({ full_name: value.label, staff_id: value.value }))
                    return {
                        ...area,
                        pr_get_data_date: form?.pr_get_data_date,
                        technicians
                    }
                }
                return area
            }))
            setLoading('')
        }).catch((error) => {
            toast.error(error.message || 'Try now')
            setLoading('')
        })

    }

    useEffect(() => {
        setLoading('fetch')
        userAxios.get('/technicians').then((response) => {
            if (response.data?.[0]) {
                setStaff(response.data.map((tech) => ({ label: tech?.staff_name, value: tech.staff_id })))
            }
            setLoading('')
        })
    }, [])

    return (
        <div className="add-edit-zone-div">
            <form onSubmit={handleSubmit}>
                <NormalInput type={'date'} label='Assign date' name='pr_get_data_date' value={form?.pr_get_data_date} onChangeFun={handleChange} />
                <MultiSelect label='Technicians' name='technicians' selectedValue={data?.technicians?.map((tech) => ({ label: tech.full_name, value: tech.staff_id }))}
                    values={staff} onChangeFun={handleMultiSelect} />

                <div className="button-div">
                    <button type={loading === 'submit' ? 'button' : 'submit'}>{loading === 'submit' ? <span className='loading-icon'><BiLoaderAlt /></span> : 'Submit'}</button>
                </div>
            </form>
            {loading === 'fetch' && <div className="loading-pop">
                <p>Loading...</p>
            </div>}
        </div>
    )
}

export default EditArea